import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
import styled, { css } from "styled-components";
import { animated } from "@faire/retailer/components/GhostLoading/animated";
export var NoResultsEmptyStateBase = function(param) {
    var title = param.title, subtitle = param.subtitle, className = param.className, divRef = param.divRef;
    return /*#__PURE__*/ _jsx(AnimatedNoResults, {
        className: className,
        children: /*#__PURE__*/ _jsxs("div", {
            ref: divRef,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraphSansMedium",
                    children: title
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "1x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    align: "center",
                    children: subtitle
                })
            ]
        })
    });
};
var NoResultsFilteredArea = styled(Column).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-c8999c03-0"
})([
    "padding:",
    ";width:100%;text-align:center;background-color:",
    ";"
], getSpacing(136, "2x"), Core.surface.muted);
var AnimatedNoResults = animated(NoResultsFilteredArea)({
    initialStyle: css([
        "opacity:0;"
    ]),
    loadedStyle: css([
        "opacity:1;"
    ])
});
